import React, { useState, useEffect } from 'react';
import './add-user-email-lookup-form.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Form, FormValidationMode, Button } from '@ampol/design-system';
import {
  adminSearchUserExists,
  lookUpUserByEmailId,
  resetUserEmailLookup,
  searchUserExists,
} from '../../actions/userActions';
import * as yup from 'yup';
import Env from 'Env';
import { useDisabledFields } from 'forms/hooks/useDisabledFields';
import Validation from 'constants/validation-messages';

/**
 * Add New User - Email Lookup Form
 * @returns JSX Element
 */
const AddUserEmailLookupForm = ({ formId, email, updateEmail, resetFormId, resetUserDetails }) => {
  const dispatch = useDispatch();

  const { isEmailDisabled } = useDisabledFields();

  const [formValues, setFormValues] = useState({
    emailId: '',
  });

  const isAdminPortal = Env.isAdminPortal();
  const isLoading = useSelector((state) => state.userStore.userEmailLookupLoading);
  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);

  const formSchema = yup.object().shape({
    emailId: yup.string().required(Validation.EMAIL_REQUIRED).email(Validation.EMAIL_VALID),
  });

  useEffect(() => {
    if (email) {
      setFormValues({
        emailId: email,
      });
    }
  }, [email]);

  const onEmailLookupSubmit = (values) => {
    const email = values.emailId;
    updateEmail(email);
    isAdminPortal
      ? dispatch(adminSearchUserExists(email))
      : dispatch(searchUserExists(assignedGrandfatherClientNumber, email));
    dispatch(lookUpUserByEmailId(email));
  };

  const resetForm = () => {
    window.dataLayer.push({
      event: 'Card_Portal_All_Clear_All',
      button_click: true,
    });
    setFormValues({
      emailId: '',
    });
    updateEmail('');
    dispatch(resetUserEmailLookup());
    resetUserDetails();
    resetFormId();
  };

  return (
    <div className='add-user-email-lookup-form'>
      <div className='add-user-email-lookup-form__form-contents'>
        <Form
          id={formId}
          schema={formSchema}
          onSubmit={onEmailLookupSubmit}
          defaultValues={formValues}
          validationMode={FormValidationMode.onChange}
        >
          <Form.Input label={'Email'} name={'emailId'} disabled={isEmailDisabled} />
        </Form>
        <div className='add-user-email-lookup-form__validate-button'>
          <Button
            label={isEmailDisabled ? 'Clear All' : 'Validate Email'}
            variant={'tertiary'}
            color={'blue'}
            formId={formId}
            type={isEmailDisabled ? 'reset' : isLoading ? 'button' : 'submit'}
            inactive={isLoading}
            onClick={isEmailDisabled ? resetForm : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default AddUserEmailLookupForm;
